module.exports = __webpack_public_path__ + "img/problems-4rus.0894794a.png";